import React, { useState, useContext, useEffect } from "react";
import { AuthContext } from "./../../context/AuthContext";
import { Link, useNavigate } from "react-router-dom";
import { Form, Spinner } from "react-bootstrap"
import API_BASE_URL from "../../config/api";

import axios from "axios";

const RequestTimeOff = ({ }) => {
  const employeeId = sessionStorage.getItem("employeeId");
  const { token } = useContext(AuthContext);
  const navigate = useNavigate();
  const [attachment, setAttachment] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    leaveType: "",
    startDate: "",
    endDate: "",
    reason: "",
    supportingDocument: "",
    employeeId: employeeId || 0,
  });

  const [notification, setNotification] = useState(null);
  const [generalMaster, setGeneralMaster] = useState([]);

  useEffect(() => {

    const fetchgeneralMaster = async () => {
      const res = await fetch(`${API_BASE_URL}/api/Config/AllGeneralMaster`, {

      });
      if (res.ok) {
        const data = await res.json();
        setGeneralMaster(data);
      }
    };
    fetchgeneralMaster();

  }, [token]);

  const handleCloseNotification = () => {
    setNotification(null);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const validateForm = () => {
    const { leaveType, startDate, endDate, reason } = formData;
  
    if (!leaveType || !startDate || !endDate || !reason) {
      return "All fields except Supporting Document are required.";
    }
  
    const today = new Date();
    today.setHours(0, 0, 0, 0); // normalize to midnight for comparison
    const start = new Date(startDate);
    const end = new Date(endDate);
  
    if (start < today) {
      return "Start Date must be today or later.";
    }
  
    if (end < today) {
      return "End Date must be today or later.";
    }
  
    if (start > end) {
      return "Start Date cannot be after End Date.";
    }
  
    return null;
  };
  

  const handleSubmit = async () => {
    const error = validateForm();
    if (error) {
      setNotification({ type: "error", message: error });
      return;
    }

    try {
      setIsLoading(true);
      const uploadData = new FormData();

      // Append all fields from formData (your state)
      uploadData.append("LeaveType", formData.leaveType);
      uploadData.append("StartDate", formData.startDate);
      uploadData.append("EndDate", formData.endDate);
      uploadData.append("Reason", formData.reason);
      uploadData.append("EmployeeId", employeeId);
  
      // Append attachment if available
      if (attachment) {
        uploadData.append("SupportingDocument", attachment);
      }
      
      const response = await axios.post(
        `${API_BASE_URL}/api/RequestTimeOff`,
        uploadData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.status == 400) {
        setNotification({
          type: "error",
          message: response.data.message,
        });
        return
      }
      
      navigate("/app/leavedashboard");
    

    } catch (err) {
      setNotification({ type: "error", message: "Error submitting request." });
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="px-4 py-5 flex justify-center">
      <div className="w-full">
        {/* 🔔 Notification Banner */}
        {notification && (
          <div
            className={`mb-4 px-4 py-3 rounded flex justify-between items-start ${notification.type === "error"
              ? "bg-red-100 text-red-700"
              : "bg-green-100 text-green-700"
              }`}
          >
            <span>{notification.message}</span>
            <button
              onClick={handleCloseNotification}
              className="ml-4 font-bold text-lg leading-none"
            >
              ×
            </button>
          </div>
        )}

        <div className="text-[32px] font-bold mb-4">Request Time Off</div>

        {/* Form Fields */}
        <div className="space-y-4">
          <div>
            <label className="block font-medium pb-1">Leave Type *</label>
          
            <select
              name="leaveType"
              value={formData.leaveType}
              onChange={handleChange}
              className="form-input w-full border rounded-xl h-12 p-3"
            >
              <option value="">Select Leave Type</option>
              {generalMaster.filter(x => x.mainId == 46).map((opt) => (
                <option key={opt.id} value={opt.id}>
                  {opt.title}
                </option>
              ))}
            </select>
          </div>

          <div className="flex gap-4">
            <div className="flex-1">
              <label className="block font-medium pb-1">Start Date *</label>
              <input
                type="date"
                name="startDate"
                value={formData.startDate}
                min={new Date().toISOString().split("T")[0]}
                onChange={handleChange}
                className="form-input w-full border rounded-xl h-12 p-3"
              />
            </div>
            <div className="flex-1">
              <label className="block font-medium pb-1">End Date *</label>
              <input
                type="date"
                name="endDate"
                value={formData.endDate}
                min={new Date().toISOString().split("T")[0]}
                onChange={handleChange}
                className="form-input w-full border rounded-xl h-12 p-3"
              />
            </div>
          </div>

          <div>
            <label className="block font-medium pb-1">Reason for Leave *</label>
            <textarea
              name="reason"
              value={formData.reason}
              onChange={handleChange}
              placeholder="Enter Reason"
              className="form-input w-full border rounded-xl min-h-[120px] p-3"
            />
          </div>

          <div>
            <label className="block font-medium pb-1">
              Supporting Documents (Optional)
            </label>
            {/* <input
              type="text"
              name="supportingDocument"
              value={formData.supportingDocument}
              onChange={handleChange}
              className="form-input w-full border rounded-xl h-12 p-3"
            />  */}
             <input
              type="file"
              className="form-input rounded-xl border h-14 p-[15px]"
              onChange={(e) => setAttachment(e.target.files[0])}
            />
          </div>

          <div className="flex justify-end mt-6">
            <Link to="/app/leavedashboard" className="px-4 ">
              <button className="cancel-btn">
                <span className="truncate">Close</span>
              </button>
            </Link>

            <button
              onClick={handleSubmit}
              className="btn-black"
            >
              {
                isLoading ?
                  <div className="flex justify-center"><Spinner animation="border" size="sm" style={{ width: '1rem', height: '1rem' }} />Submitting...</div>
                  :
                  'Submit Request'
              }

            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RequestTimeOff;
